
<div class="wrapper">
    <!-- <div id="loader-container" class="hide-loader">
        <div id="loader"></div>
    </div> -->
    <nav id="sidebar" class="sidebar js-sidebar">
        <div class="sidebar-content js-simplebar">
            <a class="sidebar-brand" href="index.html">
                <span class="sidebar-brand-text align-middle text-center">
                    <img src="../../../assets/images/royal.png" style="width: 70px;">
                </span>
                <svg class="sidebar-brand-icon align-middle" width="32px" height="32px" viewBox="0 0 24 24" fill="none" stroke="#FFFFFF" stroke-width="1.5"
                    stroke-linecap="square" stroke-linejoin="miter" color="#FFFFFF" style="margin-left: -3px">
                    <path d="M12 4L20 8.00004L12 12L4 8.00004L12 4Z"></path>
                    <path d="M20 12L12 16L4 12"></path>
                    <path d="M20 16L12 20L4 16"></path>
                </svg>
            </a>


            <ul class="sidebar-nav">
                <li class="sidebar-header">
                    
                </li>

                <li class="sidebar-item active">
                    <a routerLink="/Entites" class="sidebar-link">
                        <i class="align-middle me-2 fas fa-fw fa-align-justify"></i> <span class="align-middle">الجهات</span>
                    </a>
                </li>

                <!-- <ng-container *ngIf="userType=='1'">

                    <li class="sidebar-item active">
                        <a href="/" class="sidebar-link">
                            <i class="align-middle" data-feather="sliders"></i> <span class="align-middle">Dashboards</span>
                        </a>
                    </li>
                    
                    <li class="sidebar-item">
                        <a class="sidebar-link" href="/tickets">
                            <i class="align-middle me-2 fas fa-fw fa-question-circle"></i>
                            <span class="align-middle">Tickets</span>
                        </a>
                    </li>
    
    
                    <li class="sidebar-item">
                        <a href="#auth" data-bs-toggle="collapse" class="sidebar-link collapsed">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-aperture align-middle me-2"><circle cx="12" cy="12" r="10"></circle><line x1="14.31" y1="8" x2="20.05" y2="17.94"></line><line x1="9.69" y1="8" x2="21.17" y2="8"></line><line x1="7.38" y1="12" x2="13.12" y2="2.06"></line><line x1="9.69" y1="16" x2="3.95" y2="6.06"></line><line x1="14.31" y1="16" x2="2.83" y2="16"></line><line x1="16.62" y1="12" x2="10.88" y2="21.94"></line></svg>                      
                                  <span class="align-middle">Manage Projects</span>
                        </a>
                        <ul id="auth" class="sidebar-dropdown list-unstyled collapse " data-bs-parent="#sidebar">
                            <li class="sidebar-item"><a class="sidebar-link" href="/ProjectLayerList">Project Layer</a></li>
                            <li class="sidebar-item"><a class="sidebar-link" href="ProjectBoxComponentList">Project Layer Component</a></li>
                            <li class="sidebar-item"><a class="sidebar-link" href="Plans">Plans</a></li>
                            <li class="sidebar-item"><a class="sidebar-link" href="/QuestionList">Questions</a></li>
                            <li class="sidebar-item"><a class="sidebar-link" href="/WizardConfList">Wizard Configuration</a></li>
                            <li class="sidebar-item"><a class="sidebar-link" href="/CreatePolicyTemplate">Policy template</a></li>
                        </ul>
                    </li>

                    <li class="sidebar-item">
                        <a href="#cms" data-bs-toggle="collapse" class="sidebar-link collapsed">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-settings align-middle me-2"><circle cx="12" cy="12" r="3"></circle><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"></path></svg>
                            <span class="align-middle">Cms</span>
                        </a>
                        <ul id="cms" class="sidebar-dropdown list-unstyled collapse " data-bs-parent="#sidebar">
                            <li class="sidebar-item"><a class="sidebar-link" href="/settings/EmailSettings">Email settings</a></li>
                            <li class="sidebar-item"><a class="sidebar-link" href="/cms/InfoPage">Info page</a></li>
                            <li class="sidebar-item"><a class="sidebar-link" href="/cms/SocialMediaManage">Social Media</a></li>
                            <li class="sidebar-item"><a class="sidebar-link" href="/cms/CompanyManage">Company</a></li>
                            <li class="sidebar-item"><a class="sidebar-link" href="/cms/SupportManage">Support</a></li>
                            <li class="sidebar-item"><a class="sidebar-link" href="/cms/ExploreManage">Explore</a></li>
                            <li class="sidebar-item"><a class="sidebar-link" href="/cms/Countries">Countries</a></li>

                        </ul>
                    </li>

                    <li class="sidebar-item">
                        <a href="#HomeManage" data-bs-toggle="collapse" class="sidebar-link collapsed">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-settings align-middle me-2"><circle cx="12" cy="12" r="3"></circle><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"></path></svg>
                            <span class="align-middle">Home manage</span>
                        </a>
                        <ul id="HomeManage" class="sidebar-dropdown list-unstyled collapse " data-bs-parent="#sidebar">
                            <li class="sidebar-item"><a class="sidebar-link" href="/cms/NavbarManage">Navbar</a></li>
                            <li class="sidebar-item"><a class="sidebar-link" href="/cms/FirstBoxComponenetManage">First Box</a></li>
                            <li class="sidebar-item"><a class="sidebar-link" href="/cms/SecondBoxComponenetManage">Second Box</a></li>
                            <li class="sidebar-item"><a class="sidebar-link" href="/cms/HowDoesItWorkManage">How does it work</a></li>
                            <li class="sidebar-item"><a class="sidebar-link" href="/cms/StoryBoard">StoryBoard</a></li>
                        </ul>
                    </li>

                    <li class="sidebar-item">
                        <a class="sidebar-link" href="/Users/UsersManage">
                            <i class="align-middle me-2 fas fa-fw fa-users"></i>
                            <span>Users</span>
                        </a>
                    </li>

                </ng-container>

                <ng-container *ngIf="userType=='2'">
                    
                <li class="sidebar-item">
                    <a class="sidebar-link" href="/Projects">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-folder align-middle me-2"><path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"></path></svg>
                        <span>My Projects</span>
                    </a>
                </li>

                <li class="sidebar-item">
                    <a class="sidebar-link" href="/CreateProject">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-plus-circle align-middle me-2"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="16"></line><line x1="8" y1="12" x2="16" y2="12"></line></svg>
                        <span>Create new one</span> 
                   </a>
                </li>

                <li class="sidebar-item">
                    <a class="sidebar-link" href="/MyTicket">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-help-circle align-middle me-2"><circle cx="12" cy="12" r="10"></circle><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path><line x1="12" y1="17" x2="12.01" y2="17"></line></svg>
                        <span>Help Center</span>
                    </a>
                </li>

                </ng-container>

                <li class="sidebar-item">
                    <div class="sidebar-link" role="button" (click)="Logout()">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-log-out align-middle me-2"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path><polyline points="16 17 21 12 16 7"></polyline><line x1="21" y1="12" x2="9" y2="12"></line></svg>
                        <span>Logout</span>
                    </div>
                </li> -->


            </ul>
        </div>
    </nav>

    <div class="main">
        <nav class="navbar navbar-expand navbar-light navbar-bg">
            <a class="sidebar-toggle js-sidebar-toggle">
                <i class="hamburger align-self-center"></i>
            </a>

            <div class="navbar-collapse collapse">
                <ul class="navbar-nav navbar-align">
                    <!-- <li class="nav-item dropdown">
                        <a class="nav-icon dropdown-toggle" href="#" id="alertsDropdown" data-bs-toggle="dropdown">
                            <div class="position-relative">
                                <i class="align-middle" data-feather="bell"></i>
                                <span class="indicator">{{notificationCount}}</span>
                            </div>
                        </a>
                        <div class="dropdown-menu dropdown-menu-lg dropdown-menu-end py-0" aria-labelledby="alertsDropdown">
                            <div class="dropdown-menu-header">
                                {{notificationCount}} New Notifications
                            </div>
                            <div class="list-group">

                                <ng-container *ngFor="let item of notification">
                                    <a  href="{{item.link}}" class="list-group-item" >
                                        <div class="row g-0 align-items-center">
                                            <div class="col-2">
                                                <i class="text-warning" data-feather="bell"></i>
                                            </div>
                                            <div class="col-10">
                                                <div class="text-dark"> {{item.title}} </div>
                                                <div class="text-muted small mt-1">{{item.message}}</div>
                                                <div class="text-muted small mt-1">{{item.createdDate| date:'dd/MM/yyyy'}}</div>
                                            </div>
                                        </div>
                                    </a>
                                </ng-container>

                               
                                <a href="#" class="list-group-item">
                                    <div class="row g-0 align-items-center">
                                        <div class="col-2">
                                            <i class="text-warning" data-feather="bell"></i>
                                        </div>
                                        <div class="col-10">
                                            <div class="text-dark">Lorem ipsum</div>
                                            <div class="text-muted small mt-1">Aliquam ex eros, imperdiet vulputate hendrerit et.</div>
                                            <div class="text-muted small mt-1">2h ago</div>
                                        </div>
                                    </div>
                                </a>
                                <a href="#" class="list-group-item">
                                    <div class="row g-0 align-items-center">
                                        <div class="col-2">
                                            <i class="text-primary" data-feather="home"></i>
                                        </div>
                                        <div class="col-10">
                                            <div class="text-dark">Login from 192.186.1.8</div>
                                            <div class="text-muted small mt-1">5h ago</div>
                                        </div>
                                    </div>
                                </a>
                                <a href="#" class="list-group-item">
                                    <div class="row g-0 align-items-center">
                                        <div class="col-2">
                                            <i class="text-success" data-feather="user-plus"></i>
                                        </div>
                                        <div class="col-10">
                                            <div class="text-dark">New connection</div>
                                            <div class="text-muted small mt-1">Christina accepted your request.</div>
                                            <div class="text-muted small mt-1">14h ago</div>
                                        </div>
                                    </div>
                                </a>
                            </div>
                            <div class="dropdown-menu-footer">
                                <a href="#" class="text-muted">Show all notifications</a>
                            </div>
                        </div>
                    </li> -->

                    <!-- <li class="nav-item dropdown">
                        <a class="nav-flag dropdown-toggle pt-2" href="#" id="languageDropdown" data-bs-toggle="dropdown">
                            <i class="fa-solid fa-earth-americas fa-sm" style="color: #2254aa;"></i>
                        </a>
                        <div class="dropdown-menu dropdown-menu-end" aria-labelledby="languageDropdown">
                            <div class="dropdown-item" role="button" >
                                <span class="align-middle">English</span>
                            </div>
                            <div class="dropdown-item"  role="button">
                                <span class="align-middle">Arabic</span>
                            </div>
                        </div>
                    </li> -->

                    <li class="nav-item dropdown">
                        <a class="nav-icon pe-md-0 dropdown-toggle" href="#" data-bs-toggle="dropdown">
                            <img src="../../../assets/images/defaultUser.jpg" class="avatar img-fluid rounded" alt="User Image" />
                        </a>
                        <div class="dropdown-menu dropdown-menu-end">
                            <a class="dropdown-item" routerLink="/{{mainPath}}"><i class="align-middle me-1" data-feather="user"></i> Profile</a>
                            <a class="dropdown-item" href="#"><i class="align-middle me-1" data-feather="pie-chart"></i> Analytics</a>
                            <div class="dropdown-divider"></div>
                            <a class="dropdown-item" href="pages-settings.html"><i class="align-middle me-1" data-feather="settings"></i> Settings &
                                Privacy</a>
                            <a class="dropdown-item" href="#"><i class="align-middle me-1" data-feather="help-circle"></i> Help Center</a>
                            <div class="dropdown-divider"></div>
                            <div class="dropdown-item" style="cursor:pointer ;" >Log out</div>
                        </div>
                    </li>
                </ul>
            </div>
        </nav>

        <main class="content">
            <div class="container-fluid p-0">

                <a id="lnkAccessibility" class="access-icon">
                    <!-- <img src="/App_Themes/ThemeEn/Images/accessibility/accessibility-icon.png" /> -->
                    Accessibility Menu
                </a>

                <router-outlet></router-outlet>
            </div>
        </main>
    </div>
</div>  
